import { render, staticRenderFns } from "./slider-step.mpx?vue&type=template&id=097b8b6f&isComponent&outputPath=components%2Fslider-stepd6d52da6%2Findex"
import script from "./slider-step.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslider-stepd6d52da6%2Findex"
export * from "./slider-step.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fslider-stepd6d52da6%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports